import { EventMessage, EventType, IPublicClientApplication, createStandardPublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { msalConfig } from '../configurations';

export const initializePublicClientApplication = async (): Promise<IPublicClientApplication> => {
  const msalInstance = await createStandardPublicClientApplication(msalConfig);
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const account = event.payload as AccountInfo;
      msalInstance.setActiveAccount(account);
    }
  });

  return msalInstance;
};
